import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import FormLayout from "../FormLayout";
import CustomButton from "../CustomButton";
import { useDispatch } from "react-redux";
import { goBack } from "redux-first-history";
import SpringboroPolicy from "./SpringboroPolicy";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();

  return (
    <FormLayout title={"LIME Privacy Policy"} subtitle={"Terms and Legalities"}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justifyContent="space-evenly"
        spacing={3}
      >
        <Grid size={8}>
          <Box sx={{ height: "20em", overflow: "scroll", mt: "1em" }}>
            <SpringboroPolicy />
          </Box>
        </Grid>
      </Grid>
      <div className="btn-container single start">
        <CustomButton
          variant="outlined"
          disableElevation={true}
          label={"Back"}
          type="submit"
          onClick={() => dispatch(goBack())}
          buttonSize="btn-lg"
        />
      </div>
    </FormLayout>
  );
};

export default PrivacyPolicy;
